import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import {ThemeProvider, createTheme, styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Product_Home_Icon from "../assets/product_home_icon.svg";
import Button from "@mui/material/Button";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF',
        },
        primary: {
            main: "#FF3600",
        },
        secondary: {
            main: "#FFF",
        },
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                paper: {
                    maxWidth: '880px',
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    fontFamily: "montserrat",
                    fontSize: '1.2rem',
                    fontWeight: 'bold',
                    letterSpacing: '0.1em',
                    padding: '6px 14px',
                    borderRadius: '0',
                },
            }
        }
    }
});

const useStyles = theme => ({
    packageContent: {
        display: 'flex',
        justifyContent: 'center',
        padding: '10px 20px 30px 20px',

        [theme.breakpoints.up('md')]: {
            padding: '20px 30px 30px 30px',
        },

        '& table': {
            borderCollapse: 'collapse',
        },

        '& tr': {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '10px',

            [theme.breakpoints.up('md')]: {
                display: 'table-row',
                marginBottom: '0',
            },
        },

        '& th, & td': {
            paddingTop: '15px',
            verticalAlign: 'top',
            textAlign: 'center',

            [theme.breakpoints.up('md')]: {
                paddingTop: '30px',
                textAlign: 'left',
            },

        },
    },
    packageSpacer: {
        padding: '0',
        borderBottom: '1px #000 solid',

        '& th, & td': {
            paddingTop: '20px',
        },
    },
    packageTitleContent: {
        textAlign: 'center',

        [theme.breakpoints.up('md')]: {
            display: 'flex',
            justifyContent: 'center',

        },
    },
    packageIcon: {
        padding: '0 0 10px 0',

        [theme.breakpoints.up('md')]: {
            padding: '10px 30px 0 0',
        },
    },
    packageTitle: {
        padding: '0 0 5px 0',
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    packageDescription: {
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    packageText: {
        padding: '0',
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',

        [theme.breakpoints.up('md')]: {
            padding: '0 20px',
        },
    },
    packageBtn: {
        [theme.breakpoints.up('md')]: {
            textAlign: 'right',
            width: '145px',
            padding: '0 0 0 20px',
        },
    },
    packageLevel: {
        textTransform: 'uppercase',
    },
    packageLevelTitle: {
        display: 'block',
        fontFamily: 'Bungee',
        fontSize: '1.5em',
        lineHeight: '1.2em',
    },
    packageLevelDescription: {
        display: 'block',
        fontFamily: 'Montserrat',
        fontSize: '1.2em',
        fontWeight: 'bold',
        lineHeight: '1.4em',
        letterSpacing: '0.1em',
    },
    packageLevelDescriptionSpacer: {
        padding: '0 4px',
    },
    packagePrice: {
        display: 'flex',
        padding: '0',
        fontFamily: 'Bungee',
        fontSize: '1.9em',
        lineHeight: '1em',
        color: '#6300FF',
        justifyContent: 'center',

        [theme.breakpoints.up('md')]: {
            justifyContent: 'right',
        },
    },
    packageCurrency: {
        lineHeight: '1.4em',
        padding: '0 4px 0 0',
    },
    packageAmount: {
        fontSize: '1.6em',
        lineHeight: '1em',
    },
});

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

class PackageHomeDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        let self = this;
        const { classes } = this.props;

        const handleClose = () => {
            self.props.onClose();
        };

        return (
            <ThemeProvider theme={muiTheme}>

                <BootstrapDialog
                    onClose={handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={self.props.open}
                    PaperProps={{ sx: { borderRadius: "25px" } }}
                >
                    <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title"></DialogTitle>
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={(theme) => ({
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: theme.palette.grey[500],
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                    <DialogContent>
                        <div className={classes.packageTitleContent}>
                            <div className={classes.packageIcon}><img src={Product_Home_Icon} alt={"Home"} /></div>
                            <div>
                                <div className={classes.packageTitle}>Home Training</div>
                                <div className={classes.packageDescription}>Personalised Workout</div>
                            </div>
                        </div>

                        <div className={classes.packageContent}>
                            <table>
                                <tbody>
                                <tr>
                                    <td className={classes.packageLevel}><span className={classes.packageLevelTitle}>Trial</span><span className={classes.packageLevelDescription}>0.5h</span></td>
                                    <td className={classes.packageText}>Discuss your goals and how we can help you achieve them.</td>
                                    <td>
                                        <div className={classes.packagePrice}>
                                            <div className={classes.packageAmount}>Free</div>
                                        </div>
                                    </td>
                                    <td className={classes.packageBtn}><a href="mailto:matt@dragoncommunitygym.com"><Button variant="contained">Book Now</Button></a></td>
                                </tr>
                                <tr className={classes.packageSpacer}>
                                    <td colSpan={4}>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.packageLevel}><span className={classes.packageLevelTitle}>Basic</span><span className={classes.packageLevelDescription}>1h<span className={classes.packageLevelDescriptionSpacer}>/</span>week</span></td>
                                    <td className={classes.packageText}>All you need to start your home based wellness journey.</td>
                                    <td>
                                        <div className={classes.packagePrice}>
                                            <div className={classes.packageCurrency}>$</div><div className={classes.packageAmount}>80</div>
                                        </div>
                                    </td>
                                    <td className={classes.packageBtn}><a target="_blank" rel="noopener noreferrer" href="https://buy.stripe.com/dRmbJ3gpNdxRdbX66s6wE00"><Button variant="contained">Book Now</Button></a></td>
                                </tr>
                                <tr className={classes.packageSpacer}>
                                    <td colSpan={4}>
                                    </td>
                                </tr>
                                <tr>
                                    <td className={classes.packageLevel}><span className={classes.packageLevelTitle}>Premium</span><span className={classes.packageLevelDescription}>2h<span className={classes.packageLevelDescriptionSpacer}>/</span>week</span></td>
                                    <td className={classes.packageText}>Take things to the next level, and save <strong>$10</strong> a week.</td>
                                    <td>
                                        <div className={classes.packagePrice}>
                                            <div className={classes.packageCurrency}>$</div><div className={classes.packageAmount}>150</div>
                                        </div>
                                    </td>
                                    <td className={classes.packageBtn}><a target="_blank" rel="noopener noreferrer" href="https://buy.stripe.com/eVq9AV3D18dx2xj52o6wE03"><Button variant="contained">Book Now</Button></a></td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </DialogContent>
                </BootstrapDialog>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(PackageHomeDialog)